(function ($) {


$(function() {
    var top = $('.cta__side').offset().top - parseFloat($('.cta__side').css('marginTop').replace(/auto/, 0));
    var footTop = $('.textpage__page__bottom').offset().top - parseFloat($('.textpage__page__bottom').css('marginTop').replace(/auto/, 0));

    var maxY = footTop  - $('.cta__side').outerHeight() - 120 - 360;

    $(window).scroll(function(evt) {
        var y = $(this).scrollTop();
        if (y > top - 120) { 
            
//Quand scroll, ajoute une classe ".fixed" et supprime le Css existant 
            if (y < maxY) {
                $('.cta__side').addClass('fixed').removeAttr('style');
            } else {
                
//Quand la sidebar arrive au footer, supprime la classe "fixed" précèdement ajouté
                $('.cta__side').removeClass('fixed').css({
                    position: 'absolute',
                    bottom: '423px'
                });
            }
        } else {
            $('.cta__side').removeClass('fixed');
        }
    });
});


//    function formPlaceholder() {
//        if ($('html').attr('lang') == 'pl-PL') {
//            $('.form__cont .temat input[type="search"]').attr('placeholder', 'Wybierz temat z listy');
//            $('.form__cont .temat .wpcf7-selct-multiselct').attr('data-placeholder', 'Wybierz temat z listy');
//        } else {
//            $('.form__cont .temat input[type="search"]').attr('placeholder', 'Choose a topic from the list');
//            $('.form__cont .temat .wpcf7-selct-multiselct').attr('data-placeholder', 'Choose a topic from the list');
//        }
//    }
//
//    setTimeout(formPlaceholder, 100);

    if ($('body').hasClass('page-template-template-test')) {
        document.addEventListener('wpcf7mailsent', function (event) {

            var theLanguage = $('html').attr('lang');

            if (theLanguage == 'pl-PL') {
                location = '/gratulacje/';
            } else {
                location = '/en/congratulations/';
            }
        }, false);
    }

    $('.main__tabs>.grid-x>.cell>#media-tabs a').click(function () {
        if ($(this).hasClass('reports-active')) {
            $('.for__media__top').addClass('current-reports');
        } else {
            $('.for__media__top').removeClass('current-reports');
        }
    });

    var hash = window.location.hash;
    var s2 = hash.substring(1);

    if (hash != '') {
        $('.main__tabs a[data-id="' + s2 + '"]').click();
    }


    $('.widget.popular-posts .box').each(function () {

        href = $(this).find('.title a').attr('href');

        more = $('.sidebar__cont .text__more').text();

        $(this).find('.box__right').append('<div class="more"><a href="' + href + '">' + more + ' <span class="icon-arrow-right"></span></a></div>');

        $(this).find('.box__left img').wrap('<a href="' + href + '"></a>');

    });

    $('.tptn_posts_widget li').each(function () {

        href = $(this).find('.tptn_link').attr('href');

        more = $('.sidebar__cont .text__more').text();

        $(this).find('.tptn_after_thumb').append('<div class="more"><a href="' + href + '">' + more + ' <span class="icon-arrow-right"></span></a></div>');


    });

    $('.scroll__top-js').click(function () {
        $('html, body').animate({scrollTop: 0}, 'slow');
        return false;
    });

    $('.home1__slider-js').slick({
        dots: true,
        infinite: true,
        speed: 500,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear',
        autoplay: true
    });

    $('.home2_rep_slider-js').slick({
        dots: false,
        arrows: false,
        infinite: true,
        pauseOnHover: true,
        speed: 4000,
        autoplaySpeed: 1000,
        autoplay: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 1367,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    speed: 1200,
                    autoplaySpeed: 1500,
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 1200,
                    autoplaySpeed: 1500,
                }
            }
        ]
    });

    $('.similar__posts-js').slick({
        dots: true,
        arrows: false,
        infinite: true,
        pauseOnHover: true,
        speed: 500,
        autoplaySpeed: 4000,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    if ($('div').hasClass('form__cont')) {

        $('.checkbox__btn').on('click', function () {
            if ($('.checkbox__select__cell').hasClass('active')) {
                $('.checkbox__select__cell').removeClass('active');
            } else {
                $('.checkbox__select__cell').addClass('active');
            }
        });

        $('.show__more').on('click', function () {
            $(this).hide();
            $('.form__text .more').slideDown();
        });

        var wpcf7Elm = document.querySelector('.wpcf7');

        wpcf7Elm.addEventListener('wpcf7submit', function (event) {

            $('.checkbox__select__cell').removeClass('active');

            if ($('.checkbox__select .wpcf7-checkbox').hasClass('wpcf7-not-valid')) {
                $('.checkbox__select__cell').addClass('not-valid');
            } else {
                $('.checkbox__select__cell').removeClass('not-valid');
            }
        }, false);


        $("input[value=wszystkie]").change(function () {
            if (this.checked) {
                $('.checkbox__select input[type="checkbox"]').prop('checked', true);
            } else {
                $('.checkbox__select input[type="checkbox"]').prop('checked', false);
            }
        });

    }


    $('.package_js').on('click', function () {
        attrPackage = $(this).attr('data-package');
        var popup = new Foundation.Reveal($('#formModal'));
        popup.open();
        $(".wybrany_pakiet select option").each(function () {
            $(this).removeAttr('selected');
        });
        $('.wybrany_pakiet select option:nth-of-type(' + attrPackage + ')').prop('selected', true);

    });

    $(window).on('scroll', function () {

        if ($(window).scrollTop() > 0) {
            $('.header__top').addClass('fixed');
        } else {
            $('.header__top').removeClass('fixed');
        }
    });

})(jQuery);